import React, { useCallback, useEffect, useState } from 'react';
import { FC } from 'react';
import { ValidationBody } from 'ts/interfaces/Validation';
import { getErrorInField } from 'utils/validation';
import SelectCustom from '../SelectCustom/SelectCustom';
import withErrorBoundary from 'components/ui/withErrorBoundaries';
import { FilterOptionOption } from 'react-select/dist/declarations/src/filters';

interface FormGroupSelectProps {
  onChange: (item: string) => void;
  className?: string;
  value: string;
  label?: string;
  validation?: ValidationBody;
  isSubmitted?: boolean;
  disabled?: boolean;
  options: any[];
  placeholder?: string;
  needToTranslate?: boolean;
  showHtmlPrev?: boolean;
  movablePlaceholder?: string;
  movablePlaceholderSm?: boolean;
  movablePlaceholderIcon?: any;
  movablePlaceholderAlwaysSmall?: boolean;
  filterOption?: ((option: FilterOptionOption<any>, inputValue: string) => boolean) | undefined;
}

const FormGroupSelect: FC<FormGroupSelectProps> = ({
  validation = {},
  isSubmitted = false,
  className = '',
  ...props
}) => {
  const [value, setValue] = useState(props.value);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const isValid = useCallback(() => {
    return getErrorInField(validation!, value, isSubmitted!);
  }, [value, isSubmitted]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={className}>
      <div className="form-group">
        {props.label && (
          <label>
            {props.label} {validation?.required && <span className="color-danger">*</span>}
          </label>
        )}

        <SelectCustom
          options={props.options}
          value={props.value}
          onChange={(value) => props.onChange(value)}
          disabled={props.disabled}
          placeholder={props.placeholder}
          needToTranslate={props.needToTranslate}
          showHtmlPrev={props.showHtmlPrev}
          movablePlaceholder={props.movablePlaceholder}
          movablePlaceholderSm={props.movablePlaceholderSm}
          movablePlaceholderIcon={props.movablePlaceholderIcon}
          movablePlaceholderAlwaysSmall={props.movablePlaceholderAlwaysSmall}
          filterOption={props.filterOption}
        />
        {!!isValid() && <div className="form-invalid-text">{isValid()}</div>}
      </div>
    </div>
  );
};

export default withErrorBoundary(FormGroupSelect, 'FormGroupSelect');
